import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckBoxInput, CheckboxOption, NavigationButtons } from '@molecules/*';
import { RoutesList } from '../../../routes/Routes';
import { issueTypes } from '../../../../db/db';
import { useBuskingStore } from '../../../../hooks/useBuskingStore';
import { issueTypeSchema } from '../../validations/index';
import { ErrorMessages } from '@types';
import { parseZodErrors } from '@utils';
import { ZodError } from 'zod';
import { ErrorSummary } from '@atoms/*';

const initialData: CheckboxOption[] = issueTypes;

export const IssueType: React.FC = () => {
  const { data, get, update, resetSelective } = useBuskingStore();
  const navigate = useNavigate();

  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);

  const handleChange = (selected: CheckboxOption[]) => {
    update('issueTypes', selected);
    setErrorMessages([]);
  };

  const handleNext = () => {
    const isBufferNeeded = get('issueTypes').some(
      (type) => type.name === 'Noise',
    );

    try {
      const isBufferNeeded = get('issueTypes').some(
        (type) => type.name === 'Noise',
      );
      if (
        get('issueLocationData').is_within_borough === false &&
        !isBufferNeeded
      ) {
        resetSelective(['issueLocationData']);
      }
      const issueTypes = get('issueTypes').map((issue) => issue.name);
      issueTypeSchema.parse({
        issueTypes,
      });
      navigate(RoutesList.ISSUE_DETAILS);
    } catch (error) {
      const validationErrors = parseZodErrors(error as ZodError);
      setErrorMessages(
        validationErrors.map((error: ErrorMessages) => ({
          ...error,
          href: error.path,
        })),
      );
    }
  };

  const buttonNext = {
    onClick: handleNext,
  };

  const buttonPrevious = {
    onClick: () => navigate(RoutesList.BUSKING_HOME),
  };

  return (
    <div className="p-4">
      <ErrorSummary messages={errorMessages} />
      <CheckBoxInput
        title="What is the issue?"
        description="You can select a maximum of 4 categories"
        options={initialData?.map((option) => ({
          ...option,
          checked: data.issueTypes?.some(
            (issueType) => issueType?.id === option?.id,
          ),
        }))}
        maxOptions={4}
        onChange={handleChange}
        errorPath="issueTypes"
        errorMessages={errorMessages}
      />
      <NavigationButtons
        buttonNext={buttonNext}
        buttonPrevious={buttonPrevious}
      />
    </div>
  );
};
